/**
 * Admin
 * @module admin
 * @namespace components.admin
 */
'use strict';

angular.module('components.admin', ['restangular', 'ui.router', 'ui.select', 'ngTagsInput'])
.controller('adminController', require('./adminController.js'))
.controller('dataRightsController', require('./dataRightsController.js'))
.directive('ebAccountDropdown', require('./directives/ebAccountDropdownDirective.js'))
.directive('ebDropdown', require('./directives/ebDropdownDirective.js'))
.directive('ebCheckboxes', require('./directives/ebCheckboxesDirective.js'))
.directive('ebQueryDefaults', require('./directives/ebQueryDefaultsDirective.js'))
.directive('ebStatusToggle', require('./directives/ebStatusToggleDirective.js'))
.directive('ebTextField', require('./directives/ebTextFieldDirective.js'))
.directive('ebReadOnlyField', require('./directives/ebReadOnlyFieldDirective.js'))

.config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('home.admin', {
        url: '/admin',
        authenticate: true,
        templateUrl: require('./admin.html')
    });

    $stateProvider.state('home.dataRights', {
        url: '/dataRights',
        templateUrl: require('./dataRights.html')
    });
}]).run(function ($templateCache) {
    // In order to override the ui.select template for multiple drop downs we have to replace the
    // match-multiple.tpl.html with our own original located at...
    // <YourPathToDataProject>\RIMSDataProjectUI\src\ExactBid.DataProject.UI\node_modules\ui-select\src\bootstrap\match-multiple.tpl.html

    // Removed the selected item (btn-primary) class addition in ng-class on third nested span
    var ebMatchMultipleTemplate = '<span class="ui-select-match">' +
        '<span ng-repeat="$item in $select.selected track by $index">' +
        '<span class="ui-select-match-item btn btn-default btn-xs" tabindex="-1" type="button" ng-disabled="$select.disabled" ng-click="$selectMultiple.activeMatchIndex = $index;" ng-class="{\'select-locked\':$select.isLocked(this, $index)}" ui-select-sort="$select.selected">' +
        '<span class="close ui-select-match-close" ng-hide="$select.disabled" ng-click="$selectMultiple.removeChoice($index)">&nbsp;&times;</span><span uis-transclude-append></span>' +
        '</span>' +
        '</span>' +
        '</span>'

    $templateCache.put('bootstrap/match-multiple.tpl.html', ebMatchMultipleTemplate);
});



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/admin/index.js
// module id = 31
// module chunks = 0